import React, { useState } from 'react';
import { clsx } from 'clsx';
import { CaretRight } from '@gbm-tech/icons';

import { SidebarSubModule } from '../../../dtos';

import { PageItem } from '../PageItem';

import {
  SubItemContainer,
  SubItemMenuContainer,
  SubPagesContainer,
} from './styles';

export type SubItemProps = {
  subItem: SidebarSubModule;
};

export const SubItem: React.FC<SubItemProps> = ({ subItem }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function toggleMenu() {
    setIsMenuOpen(!isMenuOpen);
  }

  return (
    <SubItemMenuContainer>
      <SubItemContainer onClick={toggleMenu}>
        <span title={subItem.name}>{subItem.name}</span>

        <div
          className={clsx('arrow', {
            'is-open': isMenuOpen,
          })}
        >
          <CaretRight />
        </div>
      </SubItemContainer>

      <SubPagesContainer visible={isMenuOpen}>
        {subItem.pages.map((page) => (
          <PageItem key={`subPage ${page.id}`} page={page} />
        ))}
      </SubPagesContainer>
    </SubItemMenuContainer>
  );
};
